import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { memo } from 'react';

import { LayoutGridIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { workspaceAgentMentionContextsSelector } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerPopoverChrome';
import { type WorkspaceAgentBrandKitOption } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/types';

export type WorkspaceAgentMentionContextsKitMenuOptionProps = {
  kit: WorkspaceAgentBrandKitOption;
};

export const WorkspaceAgentMentionContextsKitMenuOption = memo(
  ({ kit }: WorkspaceAgentMentionContextsKitMenuOptionProps) => {
    const styles = workspaceAgentMentionContextsSelector();

    return (
      <RadixDropdownMenu.RadioItem
        className={cn(
          styles.option(),
          'cursor-default outline-none ads:data-[state=checked]:bg-hover-subtle data-[state=checked]:bg-gray-4',
        )}
        data-brand-kit-id={kit.id}
        data-testid="WORKSPACE_AGENT_MENTION_CONTEXTS_OPTION"
        value={kit.id}
      >
        <LayoutGridIcon aria-hidden className="size-4 shrink-0" />
        <span className="truncate">{kit.name}</span>
      </RadixDropdownMenu.RadioItem>
    );
  },
);

WorkspaceAgentMentionContextsKitMenuOption.displayName = 'WorkspaceAgentMentionContextsKitMenuOption';
